/**
 * Keeps the selected-value text next to each option name in sync.
 *
 * Liquid renders the initial value, and Dawn re-renders the whole picker on
 * variant change, so this only has to cover the moment between the click and
 * that re-render. Without it the label would lag one interaction behind.
 */
(function () {
  function sync(fieldset) {
    var out = fieldset.querySelector('[data-candela-selected]');
    if (!out) return;
    var checked = fieldset.querySelector('.candela-picker__input:checked');
    out.textContent = checked ? checked.dataset.longName || checked.value : '';
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.classList || !input.classList.contains('candela-picker__input')) return;
    var fieldset = input.closest('.candela-picker');
    if (fieldset) sync(fieldset);
  });
})();
